export default __webpack_public_path__ + "assets/images/532-small.png";